import { useNavigate } from 'react-router-dom';

import Avatar from '@mui/material/Avatar';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import IconButton from '@mui/material/IconButton';
import LaunchIcon from '@mui/icons-material/Launch';
import MessageIcon from '@mui/icons-material/Message';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

import './ProviderListItem.scss';
import {formatProviderName} from '../../helpers/providers';
import useUser from '../../hooks/useUser';

const ProviderListItem = props => {
  const {
    provider,
    isSelected,
    onSelect,
    onViewProfile
  } = props;
  const p = provider;
  const user = useUser();
  const navigate = useNavigate();
  return (
    <Stack 
      spacing={0} 
      className={`provider-list-item ${isSelected && 'provider-list-item--selected'}`}
      onClick={e => onSelect(e)}
    >
      <Stack 
        direction='row' 
        justifyContent='space-between' 
        className="provider-list-item__row"
      >
        <Stack 
          direction='row' 
          justifyContent='flex-start' 
          className="provider-list-item__info"
        >
          <Avatar 
            alt={`${p.firstName} ${p.lastName}`} 
            variant="square" 
            src={p.imgSrc} 
            className="provider-list-item__avatar" 
          />
          <Stack 
            spacing={0.5}
            padding={0.75}
            direction="column" 
            // className="provider-list-item__details"
          >
            <Typography
              variant='large600Tight'
              color="text.primary"
              className="provider-list-item__name"
            >
              {formatProviderName(p)}
            </Typography>

            {/* <Box className="provider-list-item__actions"> */}
              <Typography
                variant='large600Tight'
                style={{color: 'rgba(0,0,0,0.6)'}}
              >
                {p.city}{p.city && p.state ? ', ' : ''}{p.state}
              </Typography>
              <Stack direction='row' spacing={0.5} padding={0}>
                <Button
                  variant='text'
                  size='small'
                  style={{paddingLeft: '0em'}}
                  onClick={e => {
                    e.stopPropagation();
                    onViewProfile(p.id);
                  }}
                  // className="provider-list-item__view-profile-btn"
                >
                    <LaunchIcon sx={{fontSize: 18, marginRight: '0.25em'}}/>
                    View Profile
                </Button>
                {user && user.is_patient && user.patient.completed_onboarding &&
                  <Button
                    variant='text'
                    size='small'
                    onClick={() => navigate(`/clients/messages/${p.id}`)}
                  >
                    <MessageIcon sx={{fontSize: 18, marginRight: '0.25em'}}/>
                    Send Message
                  </Button>
                }
              </Stack>
            {/* </Box> */}
          </Stack>
        </Stack>
        <Stack 
          alignItems='flex-end'
          justifyContent='center'
          >
          <IconButton
            size='large'
            color='primary'
            onClick={e => {
              e.stopPropagation();
              onSelect(e);
            }}
          >
            <ChevronRightIcon fontSize='large'/>
          </IconButton>
        </Stack>
      </Stack>
    </Stack>
  );
};

export default ProviderListItem;
